import { logError } from "./logs";

export const getStockNumber = (stockPrice: number, amount: number) => {
  try {
    if (stockPrice && (!isNaN(stockPrice))) {
      return amount / stockPrice;
    }
  } catch (err) {
    logError(err as Error);
    return 0;
  }
};

export const getStockNumberFromAmount = (stockPrice: number, amount: number) => {
  try {
    if (stockPrice && (!isNaN(stockPrice))) {
      const result = Math.floor(amount / stockPrice);
      if (result !== (amount / stockPrice)) {
        return result + 1;
      }
      return amount / stockPrice;
    }
    return 0;
  } catch (err) {
    logError(err as Error);
    return 0;
  }
}

export const getSocietyPercentage = (valuation: number, stockPrice: number, amount: number) => {
  try {
    if (valuation && stockPrice && amount) {
      return ((100 * getStockNumberFromAmount(stockPrice, amount) * stockPrice) / valuation).toFixed(2);
    }
    return '0';
  } catch (err) {
    logError(err as Error);
    return '0';
  }
};

export const getTaxReduction = (amount: number, taxRate: number) => {
  try {
    if (amount) {
      return amount * taxRate / 100;
    }
    else {
      return 0;
    }
  } catch (err) {
    logError(err as Error);
    return 0;
  }
};

